import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Pagination from "../../../entities/Pagination";
import ArticleCategory from "../../../entities/productOrder/article/ArticleCategory";
import { ArticleCategoryService } from "../../../service/articleDelivery/ArticleCategoryService";

class ArticleCategorySelectStore {

    public loading: boolean;
    public commonStore: CommonStore;
    public filter?: string;
    public elements: ArticleCategory[];
    public pagination: Pagination;
    public selectedArticleCategory?: ArticleCategory;
    public isSearchDialogOpen: boolean;
    public initialLoadAmount: number;

    constructor(commonStore: CommonStore, initialLoadAmount: number, selectedArticleCategory?: ArticleCategory) {
        this.loading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, initialLoadAmount, 0, 0);
        this.elements = [];
        this.selectedArticleCategory = selectedArticleCategory;
        this.isSearchDialogOpen = false;
        this.initialLoadAmount = initialLoadAmount;
        makeAutoObservable(this);
    }

    @action
    public async search(): Promise<void> {
        this.loading = true;
        const response = await ArticleCategoryService.get(1, this.initialLoadAmount, this.filter);
        if (response.success) {
            runInAction(() => {
                this.elements = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public toggleSearchDialog(value?: boolean) {
        value = (value === undefined) ? !this.isSearchDialogOpen : value;
        if (value) {
            this.search();
        }
        this.isSearchDialogOpen = value;
    }

    get isEmpty(): boolean {
        return this.elements.length === 0;
    }

    @action
    public async setFilter(filter: string) {
        this.filter = filter;
        await this.search();
    }

    @action
    public setSelectedArticleCategory(agency?: ArticleCategory) {
        this.selectedArticleCategory = agency;
        this.isSearchDialogOpen = false;
    }

}

export default ArticleCategorySelectStore;